<template>
  <img
    class="picture"
    :class="['picture--' + size ]"
    :src="image"
    :alt="t('literal.profile_picture')"
    @error="setDefaultImage"
  >
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { getImagePath } from '@/utils/utils'

const { avatar } = defineProps({
  avatar: Object,
  size: { type: [String, Number], default: '3' }
})

const { t } = useI18n()

const image = computed(() => avatar?.small.url ?? getImagePath('placeholders/profile-picture.png'))

const setDefaultImage = e => e.target.src = getImagePath('placeholders/profile-picture.png')
</script>

<style scoped lang="scss">
.picture {
  background-color: $vlg;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;

  &--warning {
    background-color: $color--warning;
    color: $white;
  }

  &.active {
    border: 2px solid $color--secondary;
  }

  &--full {
    width: 100%;
    height: 100%;
  }

  @for $size from 1 through 20 {
    &--#{$size} {
      width: 12px * $size;
      height: 12px * $size;
    }
  }
}
</style>
